import { InjectionToken } from "@angular/core";
import { RequirementParametersPort } from "./requirement-parameters.port";

export const REQUIREMENT_PARAMETERS_PORT = new InjectionToken<RequirementParametersPort>("REQUIREMENT_PARAMETERS_PORT");
